

import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { Link } from 'react-router-dom'; // في أول الصفحة


function LoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post('https://localhost:7136/login', {
        email,
        password,
      });

      const token = res.data;
      localStorage.setItem('token', token); // حفظ التوكن

      // فك تشفير الـ JWT علشان نعرف الدور
      const decoded = jwtDecode(token); // ✅ كمان هنا
      const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      const userId = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]; // أضف السطر ده

     
      localStorage.setItem("userId", userId); // أضف السطر ده
     

      // توجيه المستخدم حسب الدور
      if (role === "Admin") {
        navigate("/admin");
      } else if (role === "Organizer") {
        navigate("/organizer");
      } else if (role === "Participant") {
        navigate("/participant");
      } else {
        setErrorMsg("دور غير معروف. تواصل مع الإدارة.");
      }

      onLoginSuccess?.(); // callback لو حبيت تستخدمه

    } catch (err) {
      setErrorMsg('فشل تسجيل الدخول. تأكد من البيانات.');
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-4"
      style={{ backgroundImage: `url('./images/photo1.jpg')` }}
    >
      <div className="bg-white bg-opacity-30 backdrop-blur-md p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">تسجيل الدخول</h2>

        {errorMsg && <p className="text-red-500 text-sm text-center mb-3">{errorMsg}</p>}

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="البريد الإلكتروني"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
            required
          />
          <input
            type="password"
            placeholder="كلمة المرور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
            required
          />
          <button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white p-3 rounded-xl transition"
          >
            دخول
          </button>
        </form>

        <div className="mt-4 text-center">
          <p className="text-gray-700">
            ليس لديك حساب؟{' '}
            {/* <a href="/register" className="text-purple-600 hover:text-purple-700 font-semibold">
              أنشئ حساب جديد
            </a> */}

            <Link to="/register" className="text-purple-600 hover:text-purple-700 font-semibold">
              أنشئ حساب جديد
</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;


